import {createContext} from 'react';

export const HardwareContext = createContext();